import React, { useEffect, useState } from 'react'
import websal from '../assets/logowebsal.png'
import { NavLink } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { loadingAction, log_out } from '../store/actions/login.actions'
import home from '../assets/sidebar/home-outline.svg'
import pencil from '../assets/sidebar/pencil-outline.svg'
import cash from '../assets/sidebar/cash-outline.svg'
import document from '../assets/sidebar/document-text-outline.svg'
import checkmark from '../assets/sidebar/checkmark-circle-outline.svg'
import airplane from '../assets/sidebar/airplane-outline.svg'
import person from '../assets/sidebar/person-outline.svg'
import briefcase from '../assets/sidebar/briefcase-outline.svg'



export const SideBar = () => {

    const [toggleMenu, setToggleMenu] = useState(false)
    const dispatch = useDispatch()
  

    const salir = () => {
        localStorage.clear()
        // dispatch(loadingAction())

        dispatch(log_out())
        
 
        // localStorage.removeItem('token')
        // localStorage.removeItem('empresaId')
        // localStorage.removeItem('emailok')
     }


    //  console.log(window.innerHeight,'window')

  return (
    <div className='contenedorSidebar'>
        
        <div className='contenedorImg' >
         {/* <li className='firma' >
            <NavLink
              to="/firmaDigital"
              onClick={() => setToggleMenu(false) }

              className={({ isActive }) =>
                isActive ? 'activeClassName' : 'BotonNav'
              }
            >
              Firma Digital
            </NavLink>
          </li> */}
  
          <NavLink
                to="/home"
              
              >
                <img src={websal} alt='logo'  />

          </NavLink>
      </div>


        <div className='liLateral' >

        <ul className='ulLi'>

     
      
                        <li>

                                <NavLink
                                    to="/home"
                                    onClick={() => setToggleMenu(false) }

                                    className={({ isActive }) =>
                                    isActive ? 'activeClassNameSideBar' : 'BotonNavSideBar'
                                    }
                                >
                                <img  className='iconos' src={home} alt='ver' />

                                    Home
                                </NavLink>
                        </li>
                         
                        
                         
                                    <li className='firma' >

                                            <NavLink
                                            to="/firmaDigital"
                                            //   onClick={() => setToggleMenu(false) }

                                            className={({ isActive }) =>
                                                isActive ? 'activeClassNameSideBar' : 'BotonNavSideBar'
                                            }
                                            >
                                            <img  className='iconos' src={pencil} alt='ver' />

                                            Firma Digital
                                            </NavLink>
                                    </li>
                         

                        

                        <li>
                                
                                <NavLink
                                    to="liquidaciones"
                                    onClick={() => setToggleMenu(false) }

                                    className={({ isActive }) =>
                                    isActive ? 'activeClassNameSideBar' : 'BotonNavSideBar'
                                    }
                                >
                                <img  className='iconos' src={cash} alt='ver' />

                                    Liquidaciones
                                </NavLink>
                        </li>


                        <li>

                                <NavLink
                                    to="licencias"
                                    onClick={() => setToggleMenu(false) }
                                    className={({ isActive }) =>
                                    isActive ? 'activeClassNameSideBar' : 'BotonNavSideBar'
                                    }
                                >
                                <img  className='iconos' src={document} alt='ver' />

                                    Licencias
                                </NavLink>
                        </li>


                        <li>
                                
                                <NavLink
                                    to="certificados"
                                    onClick={() => setToggleMenu(false) }
                                    className={({ isActive }) =>
                                    isActive ? 'activeClassNameSideBar' : 'BotonNavSideBar'
                                    }
                                >
                                <img  className='iconos' src={checkmark} alt='ver' />

                                    Certificados
                                </NavLink>
                        </li>


                        <li>

                                <NavLink
                                    to="vacaciones"
                                    onClick={() => setToggleMenu(false) }
                                    className={({ isActive }) =>
                                    isActive ? 'activeClassNameSideBar' : 'BotonNavSideBar'
                                    }
                                >
                                <img  className='iconos' src={airplane} alt='ver' />

                                    Vacaciones
                                </NavLink>
                        </li>


                        <li>


                                <NavLink
                                    to="contrato"
                                    onClick={() => setToggleMenu(false) }
                                    className={({ isActive }) =>
                                    isActive ? 'activeClassNameSideBar' : 'BotonNavSideBar'
                                    }
                                >
                                <img  className='iconos' src={briefcase} alt='ver' />

                                    Contrato
                                </NavLink>
                        </li>

                        <li>
                               
                                <NavLink
                                    to="datos"
                                    onClick={() => setToggleMenu(false) }
                                    className={({ isActive }) =>
                                    isActive ? 'activeClassNameSideBar' : 'BotonNavSideBar'
                                    }
                                >
                                <img  className='iconos' src={person} alt='ver' />

                                    Mis Datos
                                </NavLink>
                        </li>

                       


        </ul>

   

            
                <button className="salir" style={{marginTop: window.innerHeight > 775 ? '10rem' : '5rem' }} onClick={ salir }  >

                    <p>Salir</p>

                </button>




                        {/* <li className='firma' >
                            <NavLink
                            to="/firmaDigital"
                            //   onClick={() => setToggleMenu(false) }

                            className={({ isActive }) =>
                                isActive ? 'activeClassName' : 'BotonNav'
                            }
                            >
                            Documentos por Firmar
                            </NavLink>
                        </li>
                        <li className='firma' >
                            <NavLink
                            to="/firmaDigital"
                            //   onClick={() => setToggleMenu(false) }

                            className={({ isActive }) =>
                                isActive ? 'activeClassName' : 'BotonNav'
                            }
                            >
                            Documentos Firmados
                            </NavLink>
                        </li>


                        <li className='firma' >
                            <NavLink
                            to="/firmaDigital"
                            //   onClick={() => setToggleMenu(false) }

                            className={({ isActive }) =>
                                isActive ? 'activeClassName' : 'BotonNav'
                            }
                            >
                            Enrolate
                            </NavLink>
                        </li> */}



        </div>

       
        
        
    </div>
  )
}
